import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiNewRequest, ApiDocuments } from 'modules/api';
import { DocumentCategory } from 'modules/types/Document';

export const sendEarlyTerminationRequest = createAsyncThunk(
  'contract/sendEarlyTerminationRequest',
  async (
    params: {
      contractNumber: string;
      document: string;
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await ApiNewRequest.earlyTerminationRequest(params);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchEarlyTerminationDocuments = createAsyncThunk(
  'contract/fetchEarlyTerminationDocuments',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiDocuments.getDocuments({
        documentCategory: DocumentCategory.EARLY_CONTRACT_TERMINATION,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
